import React, { lazy } from 'react';
const NotFound = React.lazy(() => import("../Components/Pages/NotFound"));

// const LUFP_V1 = lazy(() => import('../Components/Pages/Splits/LUFP_V1'))
// const LUFP_V1B = lazy(() => import('../Components/Pages/Splits/LUFP_V1B'))
// const LUFP_OBV1C = lazy(() => import('../Components/Pages/Splits/LUFP_OBV1C'))
// const LUFP_V1B_2 = lazy(() => import('../Components/Pages/Splits/LUFP_V1B_2'))
// const LUFP_V1B_1 = lazy(() => import('../Components/Pages/Splits/LUFP_V1B_1'))
// const LUFP_V1C = lazy(() => import('../Components/Pages/Splits/LUFP_V1C'))
// const LUFP_SVY_V2 = lazy(() => import('../Components/Pages/Splits/LUFP_SVY_V2'))
// const LUFP_V1B2 = lazy(() => import('../Components/Pages/Splits/LUFP_V1B2'))
// const LUFP_TB_V1D = lazy(() => import('../Components/Pages/Splits/LUFP_TB_V1D'))
const LUFP_V5 = lazy(() => import('../Components/Pages/Splits/LUFP_V5'))
const LUFP_V5_5 = lazy(() => import('../Components/Pages/Splits/LUFP_V5_5'))
const LUFP_V6 = lazy(() => import('../Components/Pages/Splits/LUFP_V6'))
const LUFP_V5N1 = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1'))
const LUFP_V5N2 = lazy(() => import('../Components/Pages/Splits/LUFP_V5N2'))
const LUFP_V5A = lazy(() => import('../Components/Pages/Splits/LUFP_V5A'))
const LUFP_V5_5A = lazy(() => import('../Components/Pages/Splits/LUFP_V5_5A'))
const LUFP_V5_5B = lazy(() => import('../Components/Pages/Splits/LUFP_V5_5B'))
const LUFP_V5N1_1 = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_1'))
const LUFP_V5N1_1B = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_1B'))
const LUFP_V5N1_1A = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_1A'))
const LUFP_V5N1_1C = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_1C'))
const LUFP_V7A = lazy(() => import('../Components/Pages/Splits/LUFP_V7A'))
const LUFP_V7B = lazy(() => import('../Components/Pages/Splits/LUFP_V7B'))
const LUFP_V5N1_1B2 = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_1B2'))
const LUFP_V5N1_2A = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_2A'))
const LUFP_V8A = lazy(() => import('../Components/Pages/Splits/LUFP_V8A'))
const LUFP_V8B = lazy(() => import('../Components/Pages/Splits/LUFP_V8B'))
const LUFP_V5N1_V9 = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_V9'))
const LUFP_V5N1_V9A = lazy(() => import('../Components/Pages/Splits/LUFP_V5N1_V9A'))
const LUFP_V5C = lazy(() => import('../Components/Pages/Splits/LUFP_V5C'))
const LUFP_DF_V9 = lazy(() => import('../Components/Pages/Splits/LUFP_DF_V9'))
const LUFP_V10 = lazy(() => import('../Components/Pages/Splits/LUFP_V10'))
const LUFP_DF_V11 = lazy(() => import('../Components/Pages/Splits/LUFP_DF_V11'))
const LUFP_V12 = lazy(() => import('../Components/Pages/Splits/LUFP_V12'))
const LUFP_DF_V12_5 = lazy(() => import('../Components/Pages/Splits/LUFP_DF_V12_5'))
const LUFP_DF_VA1 = lazy(() => import('../Components/Pages/Splits/LUFP_DF_VA1'))
const RJ_DF_V1 = lazy(() => import('../Components/Pages/Splits/RJ_DF_V1'))
const MCFC_V5 = lazy(() => import('../Components/Pages/Splits/MCFC_V5'))
const MCFC_OL_V6 = lazy(() => import('../Components/Pages/Splits/MCFC_OL_V6'));
const LUFP_DF_VA2 = lazy(() => import('../Components/Pages/Splits/LUFP_DF_VA2'));
// const everydomainexceptunfair = ['lookupfinance.co.uk','scanandclaim.co.uk','optimus-claims.co.uk','direct-refunds.co.uk','savvyfinances.co.uk','onlinefinanceclaims.co.uk','localhost'];
// const unfair = ['unfairfinance.co.uk','localhost'];
// const myreclaim = ['myreclaim.co.uk','localhost'];
// const myreclaimunfair = ['myreclaim.co.uk','localhost','unfairfinance.co.uk'];
// const unfairandscanandclaim = ['unfairfinance.co.uk','scanandclaim.co.uk','localhost'];
// const everyoabaseddomain = ['lookupfinance.co.uk','scanandclaim.co.uk','savvyfinances.co.uk','localhost','myreclaim.co.uk','unfairfinance.co.uk'];
// const oahslbaseddomain = ['direct-refunds.co.uk','unfairfinance.co.uk','localhost'];
// const unfairandhsl = ['unfairfinance.co.uk','direct-refunds.co.uk','optimus-claims.co.uk','localhost'];
// const everyoaandhsldomain = ['unfairfinance.co.uk','direct-refunds.co.uk','optimus-claims.co.uk','lookupfinance.co.uk','scanandclaim.co.uk','savvyfinances.co.uk','myreclaim.co.uk','localhost'];

// Domain arrays restricted to HSL-only domains
const everydomainexceptunfair = ['optimus-claims.co.uk', 'direct-refunds.co.uk', 'onlinefinanceclaims.co.uk', 'localhost'];
const unfair = ['localhost'];
const myreclaim = ['localhost'];
const myreclaimunfair = ['localhost'];
const unfairandscanandclaim = ['localhost'];
const everyoabaseddomain = ['localhost'];
const oahslbaseddomain = ['direct-refunds.co.uk', 'localhost'];
const unfairandhsl = ['unfairfinance.co.uk', 'direct-refunds.co.uk', 'optimus-claims.co.uk', 'localhost'];
const everyoaandhsldomain = ['direct-refunds.co.uk', 'optimus-claims.co.uk', 'localhost'];
const lookupAndhsl = ['lookupfinance.co.uk', 'scanandclaim.co.uk', 'optimus-claims.co.uk', 'direct-refunds.co.uk', 'onlinefinanceclaims.co.uk', 'localhost'];

//new OA allwed domains for splits
const unfairOnly = ['localhost','unfairfinance.co.uk'];
const myreclaimOnly = ['localhost','myreclaim.co.uk'];
const lookupOnly = ['localhost','lookupfinance.co.uk'];
const unfairAndDirectOnly = ['direct-refunds.co.uk','unfairfinance.co.uk','localhost'];
const lookupscanAndClaimHsl = ['lookupfinance.co.uk','scanandclaim.co.uk','optimus-claims.co.uk','direct-refunds.co.uk','onlinefinanceclaims.co.uk','localhost'];
const scanAndClaimOnly = ['scanandclaim.co.uk','localhost'];
const justeraOnly = ['localhost','register.justera.co.uk'];
const mycarfinance = ['localhost','start.mycarfinance.claims'];
const startscanAndClaimOnly = ['start.scanandclaim.co.uk','localhost'];
export const RoutingConfig = [
    {
        path: "/LUFP_V1",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V1B",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_OBV1C",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V1B_2",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V1B_1",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V1C",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_SVY_V2",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V1B2",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_TB_V1D",
        component: NotFound,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V5",
        component: LUFP_V5,
        allowedDomains: lookupscanAndClaimHsl,
    },
    {
        path: "/LUFP_V5_5",
        component: LUFP_V5_5,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V6",
        component: LUFP_V6,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V5N1",
        component: LUFP_V5N1,
        allowedDomains: lookupAndhsl,
    },
    {
        path: "/LUFP_V5N2",
        component: LUFP_V5N2,
        allowedDomains: lookupscanAndClaimHsl,
    },
    {
        path: "/LUFP_V5A",
        component: LUFP_V5A,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V5_5A",
        component: LUFP_V5_5A,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V5_5B",
        component: LUFP_V5_5B,
        allowedDomains: everydomainexceptunfair,
    },
    {
        path: "/LUFP_V5N1_1",
        component: NotFound,
        allowedDomains: unfair,
    },
    {
        path: "/LUFP_V5N1_1B",
        component: LUFP_V5N1_1B,
        allowedDomains: unfair,
    },
    {
        path: "/LUFP_V5N1_1A",
        component: LUFP_V5N1_1A,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V5N1_1C",
        component: LUFP_V5N1_1C,
        allowedDomains: myreclaimOnly,
    },
    {
        path: "/LUFP_V7A",
        component: LUFP_V7A,
        allowedDomains: myreclaimOnly,
    },
    {
        path: "/LUFP_V7B",
        component: LUFP_V7B,
        allowedDomains: myreclaimOnly,
    },
    {
        path: "/LUFP_V5N1_1B2",
        component: LUFP_V5N1_1B2,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V5N1_2A",
        component: LUFP_V5N1_2A,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V8A",
        component: LUFP_V8A,
        allowedDomains: unfair,
    },
    {
        path: "/LUFP_V8B",
        component: LUFP_V8B,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V5N1_V9",
        component: LUFP_V5N1_V9,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V5N1_V9A",
        component: LUFP_V5N1_V9A,
        allowedDomains: unfairOnly,
    },
    {
        path: "/LUFP_V5C",
        component: LUFP_V5C,
        allowedDomains: unfairandscanandclaim,
    },
    {
        path: "/LUFP_DF_V9",
        component: LUFP_DF_V9,
        allowedDomains: everyoabaseddomain,
    },
    {
        path: "/LUFP_V10",
        component: LUFP_V10,
        allowedDomains: lookupOnly,
    },
    {
        path: "/LUFP_DF_V11",
        component: LUFP_DF_V11,
        allowedDomains: unfairandhsl,
    },
    {
        path: "/LUFP_DF_V12",
        component: LUFP_V12,
        allowedDomains: unfairAndDirectOnly,
    },
    {
        path: "/LUFP_DF_V12_5",
        component: LUFP_DF_V12_5,
        allowedDomains: oahslbaseddomain,
    },
    {
        path: "/LUFP_DF_VA1",
        component: LUFP_DF_VA1,
        allowedDomains: scanAndClaimOnly,
    },
    {
        path: "/oa/RJ_DF_V1",
        component: RJ_DF_V1,
        allowedDomains: justeraOnly,
    },
    {
        path: "/MCFC_V5",
        component: MCFC_V5,
        allowedDomains: mycarfinance,
    },
    {
        path: "/MCFC_OL_V6",
        component: MCFC_OL_V6,
        allowedDomains: mycarfinance,
    },
    {
        path: "/oa/MCFC_V5",
        component: MCFC_V5,
        allowedDomains: justeraOnly,
    },
    {
        path: "/LUFP_DF_VA2",
        component: LUFP_DF_VA2,
        allowedDomains: startscanAndClaimOnly,
    },
]


